const request = require('request');
/* globals localStorage */

export default {
    login (email, pass, cb) {
      cb = arguments[arguments.length - 1]
      // if (localStorage.token) {
      //   if (cb) cb(true)
      //   this.onChange(true)
      //   return
      // }
      checkUser(email, pass, (res) => {
        if (res.authenticated) {
          // //console.log(res)
          

          // //console.log(res.id)
          if(res.verification){
            localStorage.token = res.token
            localStorage.user = email
            localStorage.id = res.id
            localStorage.company_id = res.company_id
            localStorage.plan = res.plan
            if (cb) cb({authentication:true, verification: true})
            this.onChange(true)
          }else{
            if (cb) cb({authentication:true, verification: false})
            this.onChange(true)
          }
          
        } else {
          if(res.verification){
            if (cb) cb({authentication:false, verification: true})
            this.onChange(true)
          }else{
            if (cb) cb({authentication:false, verification: false})
            this.onChange(true)
          }
        }
      })
    },
  
    getToken () {
      return localStorage.token
    },
  
    logout (cb) {
      delete localStorage.token
      delete localStorage.user
      delete localStorage.id
      delete localStorage.company_id
      delete localStorage.plan
      if (cb) cb()
      this.onChange(false)
    },
  
    loggedIn () {
      // console.log(localStorage.token)
        var obj = {  
          method: 'POST',
          headers: {
            'Authorization': "Basic " + window.btoa(process.env.VUE_APP_AUTH),
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Origin': 'localhost',
            'Host': 'localhost'
          },
          body: JSON.stringify({
            user: localStorage.user
          })
        }
        
        return fetch(process.env.VUE_APP_APIURL+'/admin/user/tokencheck', obj)
        .then((response) => response.json())
        .then((responseData) => {
          // //console.log(responseData.token, localStorage.token)

          if (responseData.token == localStorage.token && localStorage.token !== undefined) {
            console.log("Valid Token")
            return true;
          } else{
            console.log("Invalid Token")
            return false;
          }
        })
        .catch(error => console.log(error));
    },
  
    onChange () {}
  }

  
  function checkUser (email, pass, cb) {

      var obj = {  
        method: 'POST',
        headers: {
          'Authorization': "Basic " + window.btoa(process.env.VUE_APP_AUTH),
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Origin': 'localhost',
          'Host': 'localhost'
        },
        body: JSON.stringify({
          'email': email,
          'pass': pass,
        })
      }

      console.log(obj);

      fetch(process.env.VUE_APP_APIURL+'/admin/user/login', obj).then(function(response) {
        return response.json();
      }).then(function(data) {
        if (!data.verificationerror) {
          if(data.login == true) {
            cb({
              authenticated: true,
              token: data.token,
              id: data.id,
              company_id: data.company_id,
              verification: true,
              plan: data.plan
            })
          }else{
            cb({ authenticated: false, verification: true })
          }
          
        }else{
          //console.log("verification error")
          cb({ authenticated: true, verification: false })
        }
        
        

      }).catch(function() {
        //console.log("Fehler beim Usercheck");
      });
  }